import React, { Component } from 'react';
import TOS from 'src/images/Straightline-Shipper-TOS.pdf';
import { Col, Container, Row } from 'straightline-ui';

export default class TermsOfService extends Component {
  render() {
    return (
      <Container>
        <Row className="justify-content-center">
          <Col sm="12" xl="8" className="my-5">
            <div className="header mt-md-3 text-center">
              <div className="header-body">
                <Row className="align-items-center">
                  <Col>
                    <h6 className="header-pretitle">Terms of Service</h6>
                    <h1 className="header-title">
                      Straightline - Shipper Agreement
                    </h1>
                  </Col>
                </Row>
              </div>
            </div>
            <iframe
              src={TOS}
              frameborder="0"
              title="Terms of Service"
              width="100%"
              height="700px"
            ></iframe>
            <div className="mt-5">
              <div className="mb-3">
                Straightline uses third party software including Google ,
                Stripe, and more. By using Straightline you expressly agree to
                all terms of service and privacy policies.
              </div>
              <ul className="mb-0">
                <li>
                  Google -
                  <a
                    href="https://cloud.google.com/maps-platform/terms?_gl=1*13eenr4*_ga*OTk2OTMzOTI4LjE3MzY5ODgxMDc.*_ga_NRWSTWS78N*MTc0MDI2NTMyMS4xMS4xLjE3NDAyNjU5MTguMC4wLjA.&hl=en"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    TOS
                  </a>
                  ,{'  '}
                  <a
                    href="https://policies.google.com/privacy"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Privacy Policy
                  </a>
                </li>
                <li>
                  Stripe -
                  <a
                    href="https://stripe.com/privacy"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Privacy Policy
                  </a>
                </li>
              </ul>
            </div>
          </Col>
        </Row>
      </Container>
    );
  }
}
